var React = require('react');

function IconMinus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.51367 1.75488H0.554688V0.415039H7.51367V1.75488Z"}));
}

IconMinus.defaultProps = {"viewBox":"0 0 8 2","fill":"none"};

module.exports = IconMinus;

IconMinus.default = IconMinus;
